// extracted by mini-css-extract-plugin
export default {"item":"DraggableCategory_item__vJNEl","index":"DraggableCategory_index__t3gzZ"};